import { Subject, BehaviorSubject } from 'rxjs';

export class ModalService {
    public stayOnThePage: Subject<boolean> = new Subject<boolean>();
    public isModalVisible: Subject<boolean> = new Subject<boolean>();


    public allowDelete: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isDeleteModalVisible: Subject<boolean> = new Subject<boolean>();

    public allowAddContactModalVisible: Subject<boolean> = new Subject<boolean>();

    //confirmMessage
    confirmMessage: string;
    public confirmModalVisible: Subject<boolean> = new Subject<boolean>(); // to be subscribed by the modal component
    public copyModalVisible: Subject<boolean> = new Subject<boolean>(); // to be subscribed by the modal component
    public confirmModalResult: Subject<boolean> = new Subject<boolean>(); // to be subscribed by the calling component
    public copyModalResult: Subject<string> = new Subject<string>(); // to be subscribed by the calling component

    public copySAModalResult: Subject<string> = new Subject<string>(); // to be subscribed by the calling component
    public copySAModalVisible: Subject<boolean> = new Subject<boolean>(); // to be subscribed by the modal component

    showModal() {
        this.isModalVisible.next(true);
    }

    hideModal() {
        this.isModalVisible.next(false);
    }

    showDeleteModal() {
        this.isDeleteModalVisible.next(true);
    }

    hideDeleteModal() {
        this.isDeleteModalVisible.next(false);
    }

  //to be called by the calling component
    showConfirmModal(confirmMessage: string) {
      this.confirmMessage = confirmMessage;
      this.confirmModalVisible.next(true);
    }

  //to be called by the modal component
    hideConfirmModal(isConfirm: boolean) {
      this.confirmModalResult.next(isConfirm);
    }

    //to be called by the calling component
    showCopyModal() {
      this.copyModalVisible.next(true);
    }

  //to be called by the calling component
  showCopySAModal() {
    this.copySAModalVisible.next(true);
  }

  //to be called by the modal component
    hideCopyModal(isConfirm: string) {
      this.copyModalResult.next(isConfirm);
  }

  hideCopySAModal(isConfirm: string) {
    this.copySAModalResult.next(isConfirm);
  }

    showAllowAddContactModal(){
        this.allowAddContactModalVisible.next(true);
    }
    hideAllowAddContactModal(){
        this.allowAddContactModalVisible.next(false);
    }
}
